import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Icon,
} from './styles';

const RatingStars = (props) => {
  const {
    rating,
  } = props;

  const stars = useMemo(() => {
    let starsCount = rating;
    const starsArray = [];
    for (let i = 0; i < 5; i += 1) {
      if (starsCount >= 1) {
        starsArray.push('star');
      } else if (starsCount < 1 && starsCount > 0) {
        starsArray.push('star half');
      }
      starsCount -= 1;
    }
    return starsArray;
  }, [rating]);

  return (
    <Container>
      {stars.map((star) => (
        <Icon name={star} />
      ))}
    </Container>
  );
};

RatingStars.propTypes = {
  rating: PropTypes.number.isRequired,
};

export default RatingStars;
